/**
 * Constants
 */
export const SET_ERRORS = 'site@SET_ERRORS';
export const RESET_REQUEST = 'site@RESET_REQUEST';
export const SET_HOME = 'site@SET_HOME';
export const SET_TWITTER = 'site@SET_TWITTER';
export const SET_STORIESANDARTICLES = 'site@SET_STORIES';
// export const SET_ARTICLES = 'site@SET_ARTICLES';
export const SET_PAGE = 'site@SET_PAGE';
export const SET_COMMUNITY = 'site@SET_COMMUNITY';
export const SET_SCREENINGS = 'site@SET_SCREENINGS';

/**
 * Actions creator
 */
export const setErrors = payload => ({
    type: SET_ERRORS,
    payload,
});

export const resetErrors = () => ({
    type: SET_ERRORS,
    payload: null,
});

export const resetRequest = () => ({
    type: RESET_REQUEST,
});

export const setHome = payload => ({
    type: SET_HOME,
    payload,
});

export const setTwitter = payload => ({
    type: SET_TWITTER,
    payload,
});

export const setStoriesAndArticles = (stories, articles) => ({
    type: SET_STORIESANDARTICLES,
    payload: { stories, articles },
});

// export const setArticles = payload => ({
//     type: SET_ARTICLES,
//     payload,
// })

export const setPage = payload => ({
    type: SET_PAGE,
    payload,
});

export const setCommunity = payload => ({
    type: SET_COMMUNITY,
    payload,
});

export const setScreenings = payload => ({
    type: SET_SCREENINGS,
    payload,
});
